import {
  Button,
  Heading,
  HStack,
  Modal,
  ModalContent,
  ModalOverlay,
  Stack
} from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useRef } from 'react';

import { useUserConfigStore, useUserStore } from '@store/app.store';
import Markdown from '@components/general/markdown.component';

export default function WelcomeModal({ disclosure }) {
  const tenant = useUserStore((state) => state.tenant);
  const setHasReceivedWelcome = useUserConfigStore((state) => state.setHasReceivedWelcome);
  const ctaRef = useRef(null);

  const handleClose = () => {
    setHasReceivedWelcome(true);
    disclosure.onClose();
  };

  return (
    <Modal
      size='lg'
      variant='classic'
      isOpen={disclosure.isOpen}
      onClose={handleClose}
      initialFocusRef={ctaRef}
      my={0}
    >
      <ModalOverlay bgColor='rgba(17, 22, 31, 0.7)' />
      <ModalContent p={{ base: 6, xl: 11 }}>
        <Stack gap={4}>
          <Heading
            size='lg'
            letterSpacing='tight'
          >
            {tenant?.welcome_modal?.heading}
          </Heading>
          <Markdown>{tenant?.welcome_modal?.body}</Markdown>
          <HStack mt={4}>
            <Button
              variant='reskinWhite'
              onClick={handleClose}
            >
              Dismiss
            </Button>
            <Button
              ref={ctaRef}
              as={ReactRouterLink}
              variant='reskinPrimary'
              to={tenant?.welcome_modal?.action?.url}
              onClick={handleClose}
            >
              {tenant?.welcome_modal?.action?.title}
            </Button>
          </HStack>
        </Stack>
      </ModalContent>
    </Modal>
  );
}
